/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  generateWhatsAppWebhookVerifyToken(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_webhook_verify_token`, {
      confirm_rotation: true,
    });
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  getCallingSettings(inboxId) {
    return axios.get(`${this.url}/${inboxId}/calling/settings`);
  }

  updateCallingSettings(inboxId, data) {
    return axios.patch(`${this.url}/${inboxId}/calling/update_settings`, data);
  }

  checkCallPermission(inboxId, phone) {
    return axios.get(`${this.url}/${inboxId}/calling/check_permission`, {
      params: { to: phone },
    });
  }

  requestCallPermission(inboxId, data) {
    return axios.post(
      `${this.url}/${inboxId}/calling/request_permission`,
      data
    );
  }

  initiateCalling(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/calling/initiate`, data);
  }

  preAcceptCall(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/calling/pre_accept`, data);
  }

  acceptCall(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/calling/accept`, data);
  }

  rejectCall(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/calling/reject`, data);
  }

  terminateCall(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/calling/terminate`, data);
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }

  registerTwilioWebhooks(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_twilio_webhooks`);
  }
}

export default new Inboxes();
